import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { SubBanner, SideBanner } from "src/components";
import content from "./content";

const renderInline = (text) => {
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((part, i) => {
        if (part.startsWith("**") && part.endsWith("**")) {
            return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        return <Fragment key={i}>{part}</Fragment>;
    });
};

const renderBlock = (block, idx) => {
    switch (block.type) {
        case "h2":
            return <h2 key={idx} className="mt-4 mb-2">{block.text}</h2>;
        case "h3":
            return <h3 key={idx} className="mt-3 mb-2">{block.text}</h3>;
        case "p":
            return <p key={idx} className="mb-2">{renderInline(block.text)}</p>;
        case "strong":
            return <p key={idx} className="mb-2"><strong>{block.text}</strong></p>;
        case "ul":
            return (
                <ul key={idx} className="mb-3 pl-4">
                    {block.items.map((item, i) => (
                        <li key={i}>{renderInline(item)}</li>
                    ))}
                </ul>
            );
        case "ol":
            return (
                <ol key={idx} className="mb-3 pl-4">
                    {block.items.map((item, i) => (
                        <li key={i}>{renderInline(item)}</li>
                    ))}
                </ol>
            );
        case "email":
            return (
                <p key={idx} className="mb-2">
                    <strong>{block.label}</strong>{" "}
                    <a href={`mailto:${block.email}`}>{block.email}</a>
                </p>
            );
        case "hr":
            return <hr key={idx} className="my-4" />;
        default:
            return null;
    }
};

const PrivacyPolicyView = () => {
    const { t, i18n } = useTranslation();
    const data = content[i18n.language] || content.en;

    return (
        <Fragment>
            <SubBanner title={t("home")} name={data.title} />
            <SideBanner />
            <div className="contact-2 content-area-5 language-text-dir">
                <div className="container">
                    <div className="main-title text-center">
                        <h1>{data.title}</h1>
                    </div>
                    <div className="content language-text-align">
                        <p className="mb-3"><strong>{data.lastUpdated}</strong></p>
                        {data.blocks.map(renderBlock)}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default PrivacyPolicyView;
